<template>
  <div id="EditCommunityServiceInfo" class="wrap">

    <v-app-bar  class="grey lighten-3 hidden-md-and-up"  fixed  elevate-on-scroll  >
       <v-layout class="justify-center"> <span class="title light-blue--text text--darken-3 text-center">Edit {{communityServiceHoursDetail.organization_name}}</span></v-layout>
    </v-app-bar>
    <div class="maxContainer">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 px-0">
        <v-container  class=" py-0 pb-0 px-0">
          <div @click="back" class="headerFake__back">
            <a class="headerFake__backLink">
              <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
              <span class="headerFake__backText">Back</span>
            </a>
          </div>
          <v-card class="mx-auto  elevation-0 " max-width="500">

            <v-card-title class="title font-weight-regular justify-space-between pl-0 pt-1 pb-1">
              <v-layout justify-center> <span class=" green--text">{{ currentTitle }}</span></v-layout>
            </v-card-title>

          <v-window v-model="step">
            <!-- Experience Information -->
            <v-window-item :value="1" class="mt-3">

              <!-- Experience Type-->
                <v-flex xs12 >
                  <v-select
                    v-model="communityServiceHoursDetail.experience_type"
                    :items="['Community Service','Direct Paid Patient Care Hours', 'Direct Hands-On Patient Care Hours', 'Indirect Patient Hours', 'Volunteer', ]"
                    label="Experience type"
                    outlined
                    readonly
                    disabled
                    hide-details
                  ></v-select>
                </v-flex>

                <!-- Organization Name-->
                <v-flex xs12>
                  <v-text-field
                    class="mt-5"
                    v-model="communityServiceHoursDetail.organization_name"
                    label="Organization Name"
                    outlined
                    hide-details
                  ></v-text-field>
                </v-flex>

                <!-- Organization Address-->
                <v-flex xs12>
                  <v-text-field
                    v-model="communityServiceHoursDetail.organization_address"
                    label="Address"
                    outlined
                    class="mt-5"
                    hide-details
                  ></v-text-field>
                </v-flex>

                <!-- Organization city-->
                <v-flex xs12>
                    <v-text-field
                      v-model="communityServiceHoursDetail.organization_city"
                      label="City"
                      outlined
                      class="mt-5"
                      hide-details
                    ></v-text-field>
                </v-flex>

                <!-- Organization state-->
                <v-flex xs12>
                    <v-text-field
                      v-model="communityServiceHoursDetail.organization_state"
                      label="State"
                      outlined
                      class="mt-5"
                      hide-details
                    ></v-text-field>
                </v-flex>

                <!-- Organization zip-->
                <v-flex xs12>
                    <v-text-field
                      v-model="communityServiceHoursDetail.organization_zip"
                      label="Zip"
                      outlined
                      class="mt-5"
                      hide-details
                    ></v-text-field>
                </v-flex>

            </v-window-item>

            <!-- Experience Dates -->
            <v-window-item :value="2" class="mt-3">
              <!--Start Date  -->
              <v-flex xs12 >
                  <v-menu
                    ref="menu2"
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        :value="computedStartDateFormattedMomentjs "
                        label="Start Date"
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        clearable
                        readonly
                        hide-details
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="communityServiceHoursDetail.start_date" no-title @input="menu2 = false"></v-date-picker>

                  </v-menu>
              </v-flex>

              <!--End Date  -->
              <v-flex xs12 >
                  <v-menu
                    ref="menu3"
                    :close-on-content-click="false"
                    v-model="menu3"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                        :value="computedEndDateFormattedMomentjs "
                        label="End Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        clearable
                        outlined
                        hide-details
                        class="mt-5"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="communityServiceHoursDetail.end_date" no-title @input="menu3 = false"></v-date-picker>

                  </v-menu>
              </v-flex>
            </v-window-item>

            <!-- Were you employed full time -->
            <v-window-item :value="3" class="mt-3">
              <!-- Employed Full Time -->
                  <v-container  pt-0 pb-0>

                        <v-flex xs12 >
                          <v-layout row  mt-0 align-center  justify-center>
                            <v-checkbox v-model="communityServiceHoursDetail.employed_full_time" class="mt-1 shrink" color="green" value="true" label="Yes" ></v-checkbox>
                            <v-checkbox v-model="communityServiceHoursDetail.employed_full_time" class="mt-1 shrink ml-3" color="green" value="false" label="No" ></v-checkbox>
                          </v-layout>
                        </v-flex>



                  </v-container>
                    <!-- Employed Full Time -->
                    <v-flex v-if="communityServiceHoursDetail.employed_full_time === 'true'" xs12 >
                      <v-menu
                          ref="menu4"
                          :close-on-content-click="false"
                          v-model="menu4"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              slot="activator"
                              :value="computedEmploymentDateFormattedMomentjs"
                              label="Employment Start Date"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              clearable
                              outlined
                              hide-details
                              color="green"
                              class="mx-3"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="communityServiceHoursDetail.employed_full_time_date" no-title @input="menu4= false"></v-date-picker>

                        </v-menu>
                    </v-flex>
            </v-window-item>

            <!-- Supervisor Information -->
            <v-window-item :value="4" class="mt-3">

                    <!-- Supervisor Name -->
                    <v-flex xs12>
                      <v-text-field
                        v-model="communityServiceHoursDetail.supervisor_name"
                        label="Name"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-flex>

                    <!-- Supervisor Title -->
                    <v-flex xs12>
                      <v-text-field
                        v-model="communityServiceHoursDetail.supervisor_title"
                        label="Title"
                        outlined
                        hide-details
                        class="mt-5"
                      ></v-text-field>
                    </v-flex>

                    <!-- Supervisor Phone -->
                    <v-flex xs12>
                      <v-text-field
                        v-model="communityServiceHoursDetail.supervisor_phone"
                        label="Phone"
                        outlined
                        hide-details
                        class="mt-5"
                      ></v-text-field>
                    </v-flex>

                    <!-- Supervisor Email -->
                    <v-flex xs12>
                      <v-text-field
                        v-model="communityServiceHoursDetail.supervisor_email"
                        label="Email"
                        outlined
                        hide-details
                        class="mt-5"
                      ></v-text-field>
                    </v-flex>
            </v-window-item>
          </v-window>

            <v-card-actions class="pt-5 ">
            <v-btn
              :disabled="step === 1"

              @click="step--"
              v-if="step !== 1"
            >
              Back
            </v-btn>

            <v-btn

              @click="back"
              v-if="step === 1"
              color="red"
              dark

            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="step !== 4"
              color="info"
              depressed
              @click="step++"
            >
              Next
            </v-btn>
            <v-btn
              v-if="step === 4"
              color="success"
              depressed
              @click="editCommunityServiceInfo"
            >
              Save
            </v-btn>
          </v-card-actions>

          </v-card>
        </v-container>
      </div>
    </div>

    <!-- Back Button -->
    <v-btn  v-if="step !== 1" class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>

  </div>
</template>

<script>
  import moment from 'moment'
export default {
  data() {
    return {
      step: 1,
      menu2: false,
      menu3: false,
      menu4: false
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    editCommunityServiceInfo () {
      const communityServiceInfoData = {
          experience_type : this.communityServiceHoursDetail.experience_type,
          organization_name: this.communityServiceHoursDetail.organization_name,
          organization_address: this.communityServiceHoursDetail.organization_address,
          organization_city: this.communityServiceHoursDetail.organization_city,
          organization_state: this.communityServiceHoursDetail.organization_state,
          organization_zip: this.communityServiceHoursDetail.organization_zip,
          supervisor_name: this.communityServiceHoursDetail.supervisor_name,
          supervisor_title: this.communityServiceHoursDetail.supervisor_title,
          supervisor_phone: this.communityServiceHoursDetail.supervisor_phone,
          supervisor_email: this.communityServiceHoursDetail.supervisor_email,
          start_date: this.communityServiceHoursDetail.start_date,
          end_date: this.communityServiceHoursDetail.end_date,
          employed_full_time: this.communityServiceHoursDetail.employed_full_time,
          employed_full_time_date: this.communityServiceHoursDetail.employed_full_time_date,
          communityServiceHours_id: this.communityServiceHoursDetail.id
        }

        this.$store.dispatch('setEditcommunityServiceInfo', communityServiceInfoData)
        this.$router.go(-1);
        this.step = 1;
    },
  },
  computed : {
    id () {
      return this.$route.params.id
    },
    user () {
      return this.$store.getters.user
    },
   communityServiceHoursDetail() {
      return this.$store.getters.communityServiceHoursDetail(this.id);
    },
    currentTitle () {
        switch (this.step) {
          case 1: return 'Experience Information'
          case 2: return 'Experience Dates'
          case 3: return 'Were you employed Full-Time?'
          default: return 'Supervisor Information'
        }
    },
     computedStartDateFormattedMomentjs () {
        return this.communityServiceHoursDetail.start_date ? moment(this.communityServiceHoursDetail.start_date).format('MM/DD/YYYY') : ''
      },
      computedEndDateFormattedMomentjs () {
        return this.communityServiceHoursDetail.end_date ? moment(this.communityServiceHoursDetail.end_date).format('MM/DD/YYYY') : ''
      },
      computedEmploymentDateFormattedMomentjs () {
        return this.communityServiceHoursDetail.employed_full_time_date ? moment(this.communityServiceHoursDetail.employed_full_time_date).format('MM/DD/YYYY') : ''
      }
  }
}
</script>

<style scoped>
.fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }
  @media (min-width: 960px) {
  .desktopHeader {
      width: calc(100% - 256px);
      margin-left: 256px;
  }
}

.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
  padding-bottom: 40px;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/CommunityServiceHours/EditCommunityServiceInfo.vue